import { SupportAppWindow } from '../../Apps/Models/SupportAppWindow';
import { AppSessionContext } from '../../Services/Services.Primary/SessionContext/AppSessionContext';
import { ApiConfig } from '../../Services/Services.Primary/SessionContext/Models/AppSettings/Api.Config';

export class ClientSettings {
  public PartnerApiEndpoint: string;
  public PartnerSupportApiEndpoint: string;
  public SupportApimEndpoint: string;
  public FairfaxRequestRedirectUrl: string;
  public ServiceDeskEndpoint: string;
  public PartnerCenterHomeUrl: string;
  public CustomerServiceAdminEndpoint: string;
  public PartnerApiTrafficManagerEndpoint: string;
  public PartnerSupportAdminApiEndpoint: string;
  public AdoAuthURL: string;

  public constructor(config: ApiConfig, partnerCenterHomeUrl: string) {
    this.PartnerApiEndpoint = config.siteOptions.partnerApiEndpoint;
    this.PartnerSupportApiEndpoint = config.siteOptions.supportServicesEndpoint;
    this.FairfaxRequestRedirectUrl = config.siteOptions.fairfaxRequestRedirectUrl;
    this.ServiceDeskEndpoint = config.siteOptions.serviceDeskEndpoint;
    this.SupportApimEndpoint = config.siteOptions.supportApimEndpoint;
    this.PartnerCenterHomeUrl = partnerCenterHomeUrl;
    this.CustomerServiceAdminEndpoint = config.siteOptions.customerServiceAdminEndpoint;
    this.PartnerApiTrafficManagerEndpoint = config.siteOptions.partnerApiTrafficManagerEndpoint;
    this.PartnerSupportAdminApiEndpoint = '';
    this.AdoAuthURL = '';
  }
}

export class Settings {
  private static instance: Settings;
  private clientSettings: ClientSettings;

  public static getInstance = () => {
    if (!Settings.instance) {
      Settings.instance = new Settings();
    }
    return Settings.instance;
  };

  private constructor() {
    const appSessionContext = AppSessionContext.getInstance();
    const appSettings = ((window as any).Support as SupportAppWindow).appSettings;
    this.clientSettings = new ClientSettings(
      appSettings.apiConfig,
      appSessionContext.RedirectionConfig.partnerCenterHomeUrl
    );
  }

  get ClientSettings(): ClientSettings {
    return this.clientSettings;
  }
}
